import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Button from 'flarum/common/components/Button';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import { api, toIso, when, defaultWindow } from './api';
const FILTERS = [['upcoming', 'Upcoming'], ['problems', 'Failed & cancelled'], ['published', 'Published']];
const STATUS = {
  queued: 'Queued',
  running: 'Publishing…',
  paused: 'Paused',
  published: 'Published',
  failed: 'Failed',
  cancelled: 'Cancelled'
};

/** Scheduler: what's queued, pause/resume (one or all), cancel, retry, reschedule. attrs: state */
export default class SchedulerTab extends Component {
  oninit(vnode) {
    super.oninit(vnode);
    this.filter = 'upcoming';
    this.account = '';
    this.items = null;
    this.rules = null;
    this.busy = {};
    this.resched = {};
    this.load();
  }
  load() {
    return api('GET', '/schedule?filter=' + this.filter + (this.account ? '&account=' + this.account : '')).then(r => {
      this.items = r.items || [];
      this.rules = r.rules;
    }).catch(() => this.items = []).finally(() => m.redraw());
  }
  run(key, p) {
    this.busy[key] = true;
    m.redraw();
    return p.then(r => {
      if (r && r.items) {
        this.items = r.items;
        this.rules = r.rules;
      }
      return r;
    }).catch(() => {}).finally(() => {
      this.busy[key] = false;
      m.redraw();
    });
  }
  name(id) {
    const a = (this.attrs.state.accounts || []).find(x => x.userId === id);
    return a ? a.displayName : '#' + id;
  }
  q() {
    return '?filter=' + this.filter + (this.account ? '&account=' + this.account : '');
  }
  view() {
    const r = this.rules;
    return m("div", {
      className: "VEC-scheduler"
    }, r ? m("div", {
      className: 'VEC-card VEC-rules' + (r.paused ? ' is-paused' : '')
    }, m("div", {
      className: "VEC-row-head"
    }, m("div", null, m("strong", null, r.paused ? 'Publishing is paused' : 'Publishing is on'), m("div", {
      className: "VEC-muted"
    }, r.days.join(', '), " \xB7 ", String(r.hourStart).padStart(2, '0'), ":00\u2013", String(r.hourEnd).padStart(2, '0'), ":00 (", r.timezone, ") \xB7 at least ", r.minGap, " min between posts by the same account \xB7 up to ", r.dailyMax, " a day per account \xB7 conversation turns ", r.turnGapMin, "\u2013", r.turnGapMax, " min apart \xB7 ", r.retries, " tries. Change these in Admin > Voucha Engagement.")), m("div", {
      className: "VEC-actions"
    }, m(Button, {
      className: "Button",
      icon: "fas fa-play",
      loading: this.busy.run,
      onclick: () => this.run('run', api('POST', '/schedule/run' + this.q()).then(x => {
        app.alerts.show({
          type: 'success'
        }, (x.log || []).join(' · '));
        return x;
      }))
    }, "Publish what's due now"), m(Button, {
      className: 'Button ' + (r.paused ? 'Button--primary' : 'Button--danger'),
      icon: r.paused ? 'fas fa-play-circle' : 'fas fa-pause-circle',
      loading: this.busy.pause,
      onclick: () => this.run('pause', api('POST', '/schedule/pause' + this.q(), {
        paused: !r.paused
      }))
    }, r.paused ? 'Resume publishing' : 'Pause all publishing')))) : null, m("div", {
      className: "VEC-row-head"
    }, m("div", {
      className: "VEC-filters"
    }, FILTERS.map(_ref => {
      let [k, l] = _ref;
      return m(Button, {
        className: 'Button Button--text' + (this.filter === k ? ' is-active' : ''),
        onclick: () => {
          this.filter = k;
          this.items = null;
          this.load();
        }
      }, l);
    })), m("select", {
      className: "FormControl VEC-inline-select",
      value: this.account,
      onchange: e => {
        this.account = e.target.value;
        this.items = null;
        this.load();
      }
    }, m("option", {
      value: ""
    }, "All accounts"), (this.attrs.state.accounts || []).map(a => m("option", {
      value: a.userId
    }, a.displayName)))), !this.items ? m(LoadingIndicator, null) : this.items.length ? m("ul", {
      className: "VEC-list"
    }, this.items.map(it => {
      const w = this.resched[it.id];
      return m("li", {
        className: 'VEC-account is-' + it.status,
        key: it.id
      }, m("div", {
        className: "VEC-inbox-head"
      }, m("strong", null, when(it.runAt)), m("span", {
        className: 'VEC-pill is-' + it.status
      }, STATUS[it.status] || it.status), m("span", {
        className: "VEC-pill"
      }, it.kind === 'reply' ? 'Reply' : it.kind === 'poll' ? 'Poll' : 'New discussion'), m("span", null, this.name(it.accountId)), it.conversationId ? m("span", {
        className: "VEC-pill"
      }, m("i", {
        className: "fas fa-comments"
      }), " Conversation") : null, it.backdateTo ? m("span", {
        className: "VEC-pill"
      }, m("i", {
        className: "fas fa-history"
      }), " Dated ", when(it.backdateTo)) : null, it.waitsFor ? m("span", {
        className: "VEC-muted"
      }, "waits for the post it answers") : null), m("div", {
        className: "VEC-sug-title"
      }, it.title || ''), m("div", {
        className: "VEC-muted"
      }, it.excerpt), it.error ? m("div", {
        className: "VEC-flag"
      }, m("i", {
        className: "fas fa-exclamation-circle"
      }), " ", it.error, it.attempts ? ' (tries: ' + it.attempts + ')' : '') : null, it.status === 'published' && it.publishedDiscussionId ? m("a", {
        href: '/d/' + it.publishedDiscussionId,
        target: "_blank",
        rel: "noopener"
      }, "Open on the forum") : null, it.status !== 'published' ? m("div", {
        className: "VEC-actions"
      }, it.status === 'queued' ? m(Button, {
        className: "Button",
        onclick: () => this.act(it, 'pause')
      }, "Pause") : null, it.status === 'paused' ? m(Button, {
        className: "Button",
        onclick: () => this.act(it, 'resume')
      }, "Resume") : null, ['queued', 'paused'].includes(it.status) ? m(Button, {
        className: "Button",
        onclick: () => this.act(it, 'cancel')
      }, "Cancel") : null, it.status === 'failed' ? m(Button, {
        className: "Button Button--primary",
        onclick: () => this.act(it, 'retry')
      }, "Retry (next 6 hours)") : null, m(Button, {
        className: "Button Button--text",
        onclick: () => this.resched[it.id] = w ? null : defaultWindow(24)
      }, w ? 'Close' : 'Reschedule')) : null, w ? m("div", {
        className: "VEC-schedule-row"
      }, m("span", {
        className: "VEC-muted"
      }, "Between"), m("input", {
        type: "datetime-local",
        className: "FormControl",
        value: w.earliest,
        oninput: e => w.earliest = e.target.value
      }), m("span", {
        className: "VEC-muted"
      }, "and"), m("input", {
        type: "datetime-local",
        className: "FormControl",
        value: w.latest,
        oninput: e => w.latest = e.target.value
      }), m(Button, {
        className: "Button Button--primary",
        onclick: () => this.act(it, 'reschedule', {
          earliest: toIso(w.earliest),
          latest: toIso(w.latest)
        }).then(() => this.resched[it.id] = null)
      }, "Reschedule"), m("p", {
        className: "VEC-help VEC-pastnote"
      }, "A time in the past publishes on the next run, dated to that time.")) : null);
    })) : m("p", {
      className: "VEC-empty"
    }, "Nothing here."));
  }
  act(it, action, body) {
    return this.run(action + it.id, api('POST', '/schedule/' + it.id + '/' + action + this.q(), body || {}));
  }
}